import React from 'react';
import { CheckCircle, Award, Target, Heart, ArrowRight, Phone } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { Link } from 'react-router-dom';

const APropos = () => {
  return (
    <div className="min-h-screen pt-32 pb-20 bg-gradient-to-b from-gray-50 to-white">
      {/* Page Header */}
      <section className="relative text-white py-24 mb-20 overflow-hidden" style={{
        background: 'linear-gradient(135deg, #0A2463 0%, #0D2F7E 50%, #1035A0 100%)'
      }}>
        
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white" style={{
            textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
          }}>
            À Propos de <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Chango's Renovation</span>
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed mt-6">
            {companyInfo.tagline}
          </p>
        </div>
      </section>

      {/* Company Story */}
      <section className="container mx-auto px-4 mb-20">
        <div className="max-w-6xl mx-auto">
          <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-2 border-brand-gold/20" style={{
            boxShadow: '0 0 30px rgba(249, 160, 27, 0.15)'
          }}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
              {/* Image de l'entrepreneur */}
              <div className="relative h-64 lg:h-auto">
                <img 
                  src="https://customer-assets.emergentagent.com/job_build-transform-6/artifacts/jyl4o6k2_1.jpg" 
                  alt="L'entrepreneur au travail - Chango's Renovation" 
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-hero/70 via-brand-hero/30 to-transparent lg:bg-gradient-to-r lg:from-transparent lg:via-brand-hero/20 lg:to-brand-hero/40"></div>
              </div>
              
              {/* Texte */}
              <div className="p-8 md:p-12 bg-gradient-to-br from-white to-gray-50">
                <h2 className="text-3xl md:text-4xl font-bold mb-6">
                  Notre <span style={{ 
                    background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }}>Histoire</span>
                </h2>
                <div className="space-y-4 text-gray-700 leading-relaxed text-lg">
                  <p>{companyInfo.description}</p>
                  <p className="pt-2">{companyInfo.mission}</p>
                  <p className="pt-2">{companyInfo.objective}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="relative py-20 mb-20 overflow-hidden" style={{
        background: 'linear-gradient(135deg, #0A2463 0%, #0D2F7E 50%, #1035A0 100%)'
      }}>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">
              Nos <span style={{ 
                background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>Valeurs</span>
            </h2>
            <p className="text-lg text-white/80 max-w-2xl mx-auto mt-4">
              Des principes qui guident chacune de nos actions
            </p>
          </div>

          {/* Liste compacte avec icônes dorées */}
          <div className="max-w-3xl mx-auto">
            <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 md:p-12 border-2 border-brand-gold/30">
              <div className="space-y-5">
                {companyInfo.values.map((value, index) => (
                  <div 
                    key={index}
                    className="flex items-start gap-4 group"
                  >
                    <div className="flex-shrink-0 w-8 h-8 bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-full flex items-center justify-center text-white shadow-md group-hover:scale-110 transition-transform duration-300">
                      <CheckCircle size={18} />
                    </div>
                    <p className="text-gray-800 font-medium leading-relaxed pt-1">{value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach */}
      <section className="py-20 mb-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4" style={{ color: '#0A2463' }}>
              Notre <span style={{ 
                background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>Approche</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto mt-12">
            <div className="text-center bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-brand-gold">
              <div className="w-24 h-24 bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-full flex items-center justify-center text-white mx-auto mb-6 shadow-lg" style={{
                boxShadow: '0 10px 30px rgba(249, 160, 27, 0.3)'
              }}>
                <Target size={40} />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Écoute Active</h3>
              <p className="text-gray-600 leading-relaxed">
                Nous prenons le temps de comprendre vos besoins, vos envies et vos contraintes pour vous proposer des solutions parfaitement adaptées.
              </p>
            </div>

            <div className="text-center bg-gradient-to-br from-brand-hero to-brand-blue rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 border-2 border-brand-gold" style={{
              boxShadow: '0 0 30px rgba(249, 160, 27, 0.2)'
            }}>
              <div className="w-24 h-24 bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-full flex items-center justify-center text-white mx-auto mb-6 shadow-lg">
                <Award size={40} />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4">Excellence</h3>
              <p className="text-white/90 leading-relaxed">
                Nous n'acceptons aucun compromis sur la qualité. Chaque détail compte et contribue à la réussite de votre projet.
              </p>
            </div>

            <div className="text-center bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all duration-300 border-2 border-transparent hover:border-brand-gold">
              <div className="w-24 h-24 bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-full flex items-center justify-center text-white mx-auto mb-6 shadow-lg" style={{
                boxShadow: '0 10px 30px rgba(249, 160, 27, 0.3)'
              }}>
                <Heart size={40} />
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Passion</h3>
              <p className="text-gray-600 leading-relaxed">
                Nous aimons ce que nous faisons et cela se reflète dans chaque projet que nous réalisons avec dévouement et enthousiasme.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why Trust Us */}
      <section className="container mx-auto px-4">
        <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl shadow-2xl p-8 md:p-12 border-2 border-brand-gold/30" style={{
          boxShadow: '0 0 40px rgba(249, 160, 27, 0.2)'
        }}>
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4" style={{ color: '#0A2463' }}>
            Pourquoi <span style={{ 
              background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>Nous Faire Confiance</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto mt-12">
            <div className="flex gap-4 bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-brand-gold/20">
              <div className="flex-shrink-0">
                <div className="w-14 h-14 bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-xl flex items-center justify-center text-white font-bold text-2xl shadow-lg">
                  ✓
                </div>
              </div>
              <div>
                <h3 className="font-bold text-xl text-gray-800 mb-2">Expertise Locale</h3>
                <p className="text-gray-600 leading-relaxed">
                  Une connaissance approfondie des réglementations bruxelloises et des spécificités du marché local.
                </p>
              </div>
            </div>

            <div className="flex gap-4 bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-brand-gold/20">
              <div className="flex-shrink-0">
                <div className="w-14 h-14 bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-xl flex items-center justify-center text-white font-bold text-2xl shadow-lg">
                  ✓
                </div>
              </div>
              <div>
                <h3 className="font-bold text-xl text-gray-800 mb-2">Équipe Polyvalente</h3>
                <p className="text-gray-600 leading-relaxed">
                  Tous les corps de métier réunis pour une gestion simplifiée et une coordination optimale.
                </p>
              </div>
            </div>

            <div className="flex gap-4 bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-brand-gold/20">
              <div className="flex-shrink-0">
                <div className="w-14 h-14 bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-xl flex items-center justify-center text-white font-bold text-2xl shadow-lg">
                  ✓
                </div>
              </div>
              <div>
                <h3 className="font-bold text-xl text-gray-800 mb-2">Garanties Solides</h3>
                <p className="text-gray-600 leading-relaxed">
                  Couverture complète avec garanties décennales et assurances pour votre tranquillité d'esprit.
                </p>
              </div>
            </div>

            <div className="flex gap-4 bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-brand-gold/20">
              <div className="flex-shrink-0">
                <div className="w-14 h-14 bg-gradient-to-br from-brand-gold to-brand-gold-light rounded-xl flex items-center justify-center text-white font-bold text-2xl shadow-lg">
                  ✓
                </div>
              </div>
              <div>
                <h3 className="font-bold text-xl text-gray-800 mb-2">Relation de Confiance</h3>
                <p className="text-gray-600 leading-relaxed">
                  Une communication transparente et un suivi régulier tout au long de votre projet.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="container mx-auto px-4 mt-20">
        <div className="relative rounded-3xl shadow-2xl p-8 md:p-16 text-center overflow-hidden border-2 border-brand-gold/50" style={{
          background: 'linear-gradient(135deg, #0A2463 0%, #0D2F7E 50%, #1035A0 100%)',
          boxShadow: '0 0 30px rgba(249, 160, 27, 0.2), 0 20px 60px rgba(10, 36, 99, 0.3)'
        }}>
          
          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
              Travaillons <span style={{ 
                background: 'linear-gradient(to bottom, #f9a01b 0%, #ffd230 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>Ensemble</span>
            </h2>
            <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto leading-relaxed mt-6">
              Faites-nous part de votre projet. Nous serions ravis de vous accompagner dans sa réalisation.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contact" 
                className="inline-flex items-center justify-center gap-2 bg-brand-gold text-gray-900 px-8 py-4 rounded-xl font-bold text-lg hover:bg-brand-gold-light transition-all hover:shadow-xl hover:scale-105 shadow-lg"
              >
                Demander mon devis gratuit
                <ArrowRight size={20} />
              </Link>
              <a 
                href="tel:0471664418"
                className="inline-flex items-center justify-center gap-2 bg-white text-brand-hero px-8 py-4 rounded-xl font-semibold text-lg hover:bg-brand-gold hover:text-gray-900 transition-all hover:shadow-xl hover:scale-105 shadow-lg"
              >
                <Phone size={20} />
                Appelez-nous
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default APropos;
